import './ErrorPopup.scss';
import cross from 'theme/assets/icons/Cross.svg';
import { useClearError } from '../../contexts/ErrorPopupContext';
import { useTranslation } from 'react-i18next';

export type ErrorMessage = 'selection-not-made-error' | 'selection-not-updated-error';
export type HelpMessage = 'please-try-again' | 'please-try-again-shortly';

export interface ErrorPopupProps {
  errorMessage: ErrorMessage;
  helpMessage: HelpMessage;
}

const ErrorPopup = ({ errorMessage, helpMessage }: ErrorPopupProps) => {
  const { t } = useTranslation();
  const clearError = useClearError();
  return (
    <div className='error-popup__wrapper'>
      <div className='error-popup'>
        <div className='error-popup__header-row'>
          <div className='error-popup__header'>{t(errorMessage)}</div>

          <div className='error-popup__close-icon-container' onClick={undefined}>
            <img className='error-popup__close-icon' src={cross} alt={'cross'} onClick={clearError} />
          </div>
        </div>

        <div className='error-popup__description'>{t(helpMessage)}</div>
        <div className={`error-popup__close-button`} onClick={clearError}>
          <div className='button__text'>{t('ok')}</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
